import React = require("react")
import { slugify } from "../../custom_utils/helpers"
import { HttpResult } from "widgets-for-react"
import { KeyValuePair } from "../util"
import { getWordCloudTags } from "./formstack/formstack_api"
import { Block, Container } from "./library/container"
import { Link } from "./library/link"

interface WordCloudBlockState {
  tags: HttpResult<KeyValuePair<string, number>[]>
}

export interface WordCloudBlockProps {
  readonly kind: "word_cloud_block"
  readonly title: string
  readonly description: string
  readonly label: string
  readonly form_id: string
  readonly field_id: string
  readonly number_of_options: number
  readonly primaryActionTitle: string
  readonly primaryActionUrl: string
}

const initialState: WordCloudBlockState = {
  tags: { kind: null, status: null }
}

const renderDescription = (contents: string | JSX.Element, htmlElement: JSX.Element, jsxElement: JSX.Element) => {
  return typeof contents == "string" ? (
    <htmlElement.type
      {...htmlElement.props}
      key={htmlElement.key}
      dangerouslySetInnerHTML={{ __html: contents }}
    />
  ) : (
    <jsxElement.type
      key={jsxElement.key}
      {...jsxElement.props}
    >
      {contents}
    </jsxElement.type>
  )
}
export class WordCloudBlock extends React.Component<WordCloudBlockProps, WordCloudBlockState> {
  constructor(props: WordCloudBlockProps) {
    super(props)
    this.state = initialState
  }

  componentDidMount() {
    getWordCloudTags(this.props.form_id, this.props.field_id, this.props.number_of_options).then((result) =>
      this.setState((prevState) => ({ ...prevState, tags: result }))
    )
  }

  render() {

    const { title, description, label, primaryActionTitle, primaryActionUrl } = this.props

    const tagsResult = this.state.tags

    const tags = tagsResult.kind == initialState.tags.kind ? 'loading' :
      tagsResult.kind != 'result' ? 'failed' :
        tagsResult.value

    return (
      <Container>
        <Block>
          <section className="cta cta--block cta--large">
            {title && <header className="cta__header">
              <h2 data-anchor={slugify(title)} className="cta__title title--l">{title}</h2>
            </header>}

            <div className="cta__content">
              {renderDescription(description, <p className="cta__text" />, <div />)}

              <div className="cta__tags">
                {label && <h3 className="cta__tags-title title--s">{label}</h3>}
                {
                  tags == 'loading' ? <div className="cta__tags-loader">Laden...</div> :
                  tags == 'failed' ? <div className="cta__tags-loader">Laden mislukt.</div> :
                  <ul className="cta__tags-list">
                    {tags.map((tag, index) =>
                      <li className="cta__tags-item" key={`cta-tag-${index}`}>
                        <div className="cta__tag">
                          <span className="cta__tag-title">{tag.Key}</span>
                          <div className="cta__tag-count">
                            <span className="cta__tag-number"><span className="sr-text">Aantal geinteresseerden: </span>{tag.Value}</span>
                            <span className="cta__tag-icon" aria-hidden="true"></span>
                          </div>
                        </div>
                      </li>
                    )}
                  </ul>
                }
              </div>
            </div>

            {primaryActionTitle && primaryActionUrl &&
              <footer className="cta__footer">
                <Link url={primaryActionUrl} className="cta__button button">
                  {primaryActionTitle}
                </Link>
              </footer>}
          </section>
        </Block>
      </Container>
    )
  }
}
